var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notification" }, [
    _c("div", {}, [_vm._v(_vm._s(_vm.message))]),
    _c("div", { staticClass: "close", on: { click: _vm.close } }, [
      _c("i", { staticClass: "icon-plus" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }